import React, { useState, useEffect } from "react";
import { Header } from "../../components/Header/Header";
import {
  getDadosJogo,
  addJogador,
  getJogadores,
  removeJogador,
} from "../../../db/db";
import { useNavigate } from "react-router-dom";
import "./IncluirJogadores.css";
import { Footer } from "../../components/Footer/Footer";

const IncluirJogadores = () => {
  const [nomeJogador, setNomeJogador] = useState("");
  const [jogadores, setJogadores] = useState([]);
  const [nextId, setNextId] = useState(1);

  useEffect(() => {
    const fetchJogo = async () => {
      try {
        const jogos = await getDadosJogo(); // Recupera todos os jogos
        if (jogos.length > 0) {
          console.log("Jogo Criado:", jogos[jogos.length - 1]); // Mostra o último jogo criado
        } else {
          console.log("Nenhum jogo encontrado.");
        }
      } catch (error) {
        console.error("Erro ao recuperar o jogo:", error);
      }
    };

    fetchJogo();
  }, []);

  useEffect(() => {
    const fetchJogadores = async () => {
      const jogadoresDB = await getJogadores();
      if (jogadoresDB.length > 0) {
        setJogadores(jogadoresDB);
        setNextId(jogadoresDB.length + 1);
      }
    };
    fetchJogadores();
  }, []);

  // Função para adicionar jogador
  const handleAddJogador = async () => {
    if (!nomeJogador) {
      alert("Digite o nome do jogador");
      return;
    }

    const jogador = {
      id: nextId,
      id_fixo: nextId,
      nome: nomeJogador,
      gols: 0,
      assistencias: 0,
      vitorias: 0,
      empates: 0,
      derrotas: 0,
      qt_partidas: 0,
      jogosSemTomarGol: 0,
      influenciaVitoria: 0,
      desempenhoAcumulado: 0,
      overallGlobal: 65,
      overallTurma: 65,
    };
    await addJogador(jogador); // Salva no IndexedDB

    // Atualiza a lista localmente
    setJogadores([...jogadores, jogador]);
    setNomeJogador(""); // Limpa o campo de input
    setNextId(nextId + 1); // Incrementa o próximo ID
  };

  // Função para remover jogador
  const handleRemoveJogador = async (id) => {
    await removeJogador(id); // Remove do IndexedDB
    setJogadores(jogadores.filter((jogador) => jogador.id !== id)); // Atualiza a lista localmente
  };

  // Função para avançar para a próxima página (PreJogo)
  const navigate = useNavigate();

  const handleAvancar = () => {
    if (jogadores.length < 2) {
      // Verificar se há jogadores suficientes antes de avançar
      alert("Você deve adicionar pelo menos 2 jogadores para continuar.");
      return;
    }
    navigate("/novo-amistoso/pre-jogo");
  };

  return (
    <>
      <Header />

      <div className="body">
        <div className="center">
          <div className="body-content card">
            <div className="topo-page">
              <strong># Novo Amistoso | Incluir Jogadores</strong>
            </div>

            <div className="area-novo-jogo">
              <label className="label-app" htmlFor="nome-jogador">
                | Nome jogador:
              </label>
              <div className="input-area">
                <input
                  className="input-app"
                  type="text"
                  name="nome-jogador"
                  id="nome-jogador"
                  value={nomeJogador}
                  onChange={(e) => setNomeJogador(e.target.value)}
                />
                <button className="add" onClick={handleAddJogador}>
                  <svg
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 23H43M23 3V43"
                      stroke="white"
                      stroke-width="5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>

              {jogadores.length > 0 && (
                <>
                  <div className="lista-jogadores">
                    {jogadores.map((jogador, index) => (
                      <div key={jogador.id} className="jogador-item">
                        <div className="ordem-jogador">{index + 1}.</div>
                        <span>{jogador.nome}</span>
                        <button
                          className="remove-jogador"
                          onClick={() => handleRemoveJogador(jogador.id)}
                        >
                          <svg
                            width="46"
                            height="6"
                            viewBox="0 0 46 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 3H43"
                              stroke="white"
                              stroke-width="5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                  <button
                    id="novo-jogo"
                    className="btn-default"
                    onClick={handleAvancar}
                  >
                    AVANÇAR
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default IncluirJogadores;
